<template>
  <div id="func-50-detalhe">
    <funcionalidade-header :titulo="tituloNavegacao"></funcionalidade-header>
    <div v-if="!$route.query.idGuia">
      <solicitacao-detalhe></solicitacao-detalhe>
    </div>
    <div v-if="$route.query.idGuia">
      <extrato-detalhe></extrato-detalhe>
    </div>
  </div>
</template>
<script>
import FuncionalidadeHeader from '@/components/FuncionalidadeHeader/FuncionalidadeHeader'
import SolicitacaoDetalhe from '@/components/TemplateSolicitacao/componentes/SolicitacaoDetalhe'
import ExtratoDetalhe from '@/components/TemplateSolicitacao/componentes/ExtratoDetalhe'
import { mapState } from 'vuex'
export default {
  components: { SolicitacaoDetalhe, FuncionalidadeHeader, ExtratoDetalhe },
  computed: {
    ...mapState('SetupApp', ['funcionalidade']),
    tituloNavegacao () {
      return this.funcionalidade.parametros.textos.tituloTelaDetalheSolicitacao
    }
  }
}
</script>
